import { ProjectCollection } from "../../components/ToolPage";
import type { BriefingProject } from "../../types/briefing";
import RecentBriefs from "./RecentBriefs";
export default function BriefingProjectList({
  projects,
  error,
  onRetry,
  onEdit,
  onDelete,
  onCreateBrief,
}: {
  projects: BriefingProject[];
  error?: string | null;
  onRetry: () => void;
  onEdit: (project: BriefingProject) => void;
  onDelete: (project: BriefingProject) => void;
  onCreateBrief: (project: BriefingProject) => void;
}) {
  return (
    <ProjectCollection
      toolId="briefings"
      error={error}
      onRetry={onRetry}
      recent={<RecentBriefs />}
      recentLabel="Recent briefs"
      items={projects.map((p) => ({
        id: p.id,
        title: p.name,
        href: `/briefings/${encodeURIComponent(p.id)}`,
        updatedAt: p.updated_at || p.created_at,
        metadata: [
          { label: "Briefs", value: p.analysis_count ?? "—" },
          {
            label: p.updated_at ? "Updated" : "Created",
            value: new Date(p.updated_at || p.created_at).toLocaleDateString(),
          },
        ],
        actions: [
          { label: "New brief", onSelect: () => onCreateBrief(p) },
          { label: "Rename and settings", onSelect: () => onEdit(p) },
          { label: "Delete project", onSelect: () => onDelete(p) },
        ],
      }))}
    />
  );
}
